import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/FirldTrips/2023/Class12/1.jpg';
// import p2 from 'assests/Photos/FirldTrips/2023/Class12/2.jpg';
// import p3 from 'assests/Photos/FirldTrips/2023/Class12/3.jpg';
// import p4 from 'assests/Photos/FirldTrips/2023/Class12/4.jpg';
// import p5 from 'assests/Photos/FirldTrips/2023/Class12/5.jpg';
// import p6 from 'assests/Photos/FirldTrips/2023/Class12/6.jpg';
// import p7 from 'assests/Photos/FirldTrips/2023/Class12/7.jpg';
// import p8 from 'assests/Photos/FirldTrips/2023/Class12/8.jpg';
// import p9 from 'assests/Photos/FirldTrips/2023/Class12/9.jpg';
// import p10 from 'assests/Photos/FirldTrips/2023/Class12/10.jpg';
// import p11 from 'assests/Photos/FirldTrips/2023/Class12/11.jpg';
// import p12 from 'assests/Photos/FirldTrips/2023/Class12/12.jpg';
// import p13 from 'assests/Photos/FirldTrips/2023/Class10/13.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar_2023 from '../Sidebar_2023';


const CurricularClass122023 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });


    const [config, setConfig] = useState({ base_image_archive_url: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class12/1.webp`;
    const p2 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class12/2.webp`;
    const p3 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class12/3.webp`;
    const p4 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class12/4.webp`;
    const p5 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class12/5.webp`;
    const p6 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class12/6.webp`;
    const p7 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class12/7.webp`;
    const p8 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class12/8.webp`;
    const p9 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class12/9.webp`;
    const p10 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class12/10.webp`;
    const p11 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class12/11.webp`;
    const p12 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class12/12.webp`;
  

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
        {
          src: p6,
          source: p6,
          rows: 1,
          cols: 1,
      }, {
          src: p7,
          source: p7,
          rows: 1,
          cols: 1,
      },
      {
          src: p8,
          source: p8,
          rows: 1,
          cols: 1,
      },
      {
          src: p9,
          source: p9,
          rows: 1,
          cols: 1,
      },
      {
          src: p10,
          source: p10,
          rows: 1,
          cols: 1,
      },
      {
          src: p11,
          source: p11,
          rows: 1,
          cols: 1,
      },
      {
          src: p12,
          source: p12,
          rows: 1,
          cols: 1,
      },
       

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                Field Trip To Area 83
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 12   Date: 9 OCTOBER 2023

                                </Typography>
                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The students of grade 12 of National Public School Yeshwanthpur embarked on a memorable field trip to Area 83, Bannergatta South, on Monday October 9, 2023. The resort was adjoining a lake and was covered with greenery all around which provided the much needed respite for tired eyes. The day was filled with exciting experiences that brought them closer together and provided a break from their usual routine. 
                                    <br />
                                    Their adventure began at 7 AM when they gathered at the school and boarded two buses bound for the resort. During the journey, they enlivened the atmosphere with music, singing and spontaneous dance sessions, creating a lively and joyful atmosphere. Upon arrival, they were ushered to the resort's recreational area, where they engaged in a series of team-building activities organized by the staff. These activities encouraged teamwork, communication and problem-solving, fostering a sense of camaraderie among the students. Later, they were divided into four groups and each group had the opportunity to participate in thrilling activities like the Giant Swing, Human Foosball, Bubble Soccer, Archery and the alluring pool. These activities not only provided excitement but also challenged them physically and mentally. The day was a getaway from their usual academic routine, offering a chance to relax, unwind and enjoy the company of their peers. After an action-packed day, they came together for a group photo, capturing the essence of their shared experiences. Sumptuous food, well planned activities, impressive surroundings and the company of likeminded energetic friends ensured the day ended with thrilling experiences, meaningful connections and everlasting memories.
                                </Typography>
                            </Box>


                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                            <Sidebar_2023 />
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default CurricularClass122023;